module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('y-shelf', {
    attrs: {
      "title": "售后服务"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "padding": "100px 0",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/support.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "support"
  }, [_vm._v("如有疑问请联系邮箱1012139570@qq.com")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43125eff","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/children/support.vue
// module id = 628
// module chunks = 0